import type { CaseType, CaseStatus, Priority, ContactRole, PaymentStatus } from './types';

export const ACCESS_CODE = 'avocatdemo';

export const COLORS = {
  urgent: '#E24B4A',
  warn: '#BA7517',
  ok: '#3B6D11',
  blue: '#185FA5',
  purple: '#534AB7',
  gray: '#5F5E5A',
} as const;

export const CASE_TYPES: CaseType[] = [
  'Civil',
  'Pénal',
  'Commercial',
  'Social',
  'Famille',
  'Immobilier',
  'Administratif',
  'Autre',
];

export const CASE_STATUSES: CaseStatus[] = [
  'En cours',
  'En attente',
  'Plaidé',
  'Archivé',
];

export const PRIORITIES: Priority[] = ['Haute', 'Normale', 'Basse'];

export const CONTACT_ROLES: ContactRole[] = [
  'Partie adverse',
  'Avocat adverse',
  'Huissier',
  'Notaire',
  'Expert',
  'Juridiction',
  'Assureur',
  'Autre',
];

export const PAYMENT_STATUSES: PaymentStatus[] = [
  'En attente',
  'Acompte versé',
  'Partiellement réglé',
  'Soldé',
  'Impayé',
];

export const DAYS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'] as const;
export const MONTHS = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
] as const;

export const LETTER_TEMPLATES = [
  {
    id: 'mdc1',
    titre: 'Mise en demeure',
    template: (clientName: string, avocatName: string, avocatBarreau: string) => `
Maître ${avocatName}
Barreau de ${avocatBarreau}

${new Date().toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })}

Mise en demeure

Maître,

Par la présente, et au nom de mon client ${clientName}, j'ai l'honneur de vous mettre en demeure de [objet] dans un délai de huit (8) jours à compter de la réception de ce courrier.

A défaut, je me verrai contraint(e) d'engager toutes voies de droit utiles.

Je vous prie d'agréer, Maître, l'expression de ma considération distinguée.

Maître ${avocatName}
    `,
  },
  {
    id: 'mdc2',
    titre: 'Accusé de réception de dossier',
    template: (clientName: string, avocatName: string) => `
${new Date().toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })}

Accusé de réception

${clientName},

J'ai bien reçu votre dossier et vous confirme avoir pris en charge votre affaire.

Je prendrai contact avec vous prochainement afin de vous exposer les démarches envisagées.

Je vous prie d'agréer l'expression de mes salutations distinguées.

Maître ${avocatName}
    `,
  },
  {
    id: 'mdc3',
    titre: 'Convocation client',
    template: (clientName: string, avocatName: string, tel: string, email: string) => `
${clientName}

${new Date().toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })}

Convocation à entretien

${clientName},

Je vous serais reconnaissant(e) de bien vouloir vous présenter à mon cabinet le [DATE] à [HEURE], afin de faire le point sur votre dossier.

Merci de me confirmer votre disponibilité.

Je vous prie d'agréer l'expression de mes salutations distinguées.

Maître ${avocatName}
${tel} — ${email}
    `,
  },
  {
    id: 'mdc4',
    titre: 'Demande de pièces',
    template: (clientName: string, avocatName: string) => `
${clientName}

${new Date().toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })}

Demande de pièces complémentaires

${clientName},

Afin de poursuivre le traitement de votre dossier, je vous serais reconnaissant(e) de bien vouloir me faire parvenir les documents suivants:

— [Pièce 1]
— [Pièce 2]
— [Pièce 3]

Merci de me les adresser dans les meilleurs délais.

Je vous prie d'agréer l'expression de mes salutations distinguées.

Maître ${avocatName}
    `,
  },
  {
    id: 'mdc5',
    titre: 'Clôture de dossier',
    template: (clientName: string, avocatName: string) => `
${clientName}

${new Date().toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })}

Clôture de dossier

${clientName},

J'ai le plaisir de vous informer que votre dossier est désormais clôturé. [Résumé du résultat obtenu.]

Je vous adresse ci-joint le décompte final des honoraires.

Je reste à votre disposition pour toute question.

Je vous prie d'agréer l'expression de mes salutations distinguées.

Maître ${avocatName}
    `,
  },
] as const;
